import { Box, Button, Modal, TextareaAutosize, Typography } from "@material-ui/core"
import { ModalStyles } from "../../styles";
import { useFormik } from "formik";
import { Api } from "../../lib/api";
import { useSnackbar } from "notistack";

type BulkImportPipelineModalProps = {
    open: boolean
    onClose: () => void
    userSlug: string
    websiteSlug: string
    onUrlSubmitted: () => void
}

export const BulkImportPipelineModal = ({ open, onClose, userSlug, websiteSlug, onUrlSubmitted }: BulkImportPipelineModalProps) => {
    const modalStyles = ModalStyles();

    const { enqueueSnackbar } = useSnackbar();

    const formik = useFormik({
        initialValues: {
            urls: ""
        },
        onSubmit: async (data) => {
            // Grab and parse the urls
            const urls = data.urls.split("\n").map(u => u.trim()).filter(u => u.length > 0);

            try {
                const res = await Api.bulkImportPipeline(userSlug, websiteSlug, urls);
                enqueueSnackbar(`Created ${res.data.created} and ${res.data.existing} existed`, { variant: "success" });
                onUrlSubmitted();
            } catch (error: any) {
                enqueueSnackbar(error.response.data.message, { variant: "error" });
            }
            onClose();
        },
        enableReinitialize: true,
    });

    return <Modal
        open={open}
        disableBackdropClick={true}
        onClose={onClose}
    >
        <div className={modalStyles.paper}>
            <>
                <Box mb={1}>
                    <Typography variant="h4" component="h4">
                        {`Batch Import for source  ${websiteSlug}`}
                    </Typography>
                </Box>
                <Box mb={3}>
                    <Typography variant="body1" >
                        Input each URL in a new line.
                    </Typography>
                </Box>
                <TextareaAutosize
                    rowsMin={25}
                    rowsMax={25}
                    placeholder="Paste urls here"
                    style={{
                        width: "100%"
                    }}
                    name="urls"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.urls}
                />
                <Box mt={2}>
                    <Button variant="contained" onClick={onClose} style={{ marginRight: 20 }} >Cancel</Button>
                    <Button variant="contained" color="primary" onClick={() => formik.submitForm()}>Import</Button>
                </Box>
            </>
        </div>
    </Modal>
}